module.exports = __webpack_public_path__ + "static/img/friends-invitation-bg-new.f3fe806.png";